export const expenseItems = {
  title: 'Khoản mục chi phí',
  titles: {
    create: 'Thêm khoản mục chi phí',
    edit: 'Sửa khoản mục chi phí',
    detail: 'Chi tiết khoản mục chi phí',
    list: 'Danh mục khoản mục chi phí',
    addQuick: 'Thêm nhanh',
  },
  sections: {
    basic: 'Thông tin cơ bản',
  },
  fields: {
    code: 'Mã khoản mục',
    name: 'Khoản mục',
    templateContent: 'Nội dung mẫu',
    defaultCurrency: 'Loại tiền mặc định',
    sortOrder: 'STT',
    status: 'Trạng thái',
    onOffAction: 'Bật / tắt',
    actions: 'Thao tác',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
  },
  status: {
    active: 'Hoạt động',
    inactive: 'Ngừng',
  },
  messages: {
    noData: 'Không có dữ liệu',
  },
  filter: {
    placeholder: 'Tìm theo mã, khoản mục...',
  },
}
